import { SHOW_ORDER_SUBMIT_MODAL, HIDE_ORDER_SUBMIT_MODAL, Action } from 'actions';

export interface State {
  ideaId?: number;
}

const initState: State = {};

export default function reducer(state: State = initState, action: Action): State {
  switch (action.type) {
    case SHOW_ORDER_SUBMIT_MODAL:
      return {
        ...state,
        ideaId: action.payload.ideaId,
      };
    case HIDE_ORDER_SUBMIT_MODAL:
      return initState;
    default:
      return state;
  }
}
